// src/middleware/AuthMiddleware.js
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getAuthToken } from '../utils/auth';
import { toast } from 'react-toastify';

const AuthMiddleware = ({ children }) => {
	const navigate = useNavigate();
	useEffect(() => {
		const token = getAuthToken();
		if (!token) {
			toast.error('Please login to access this page');
			navigate('/');
		}
	}, [navigate]);

	return getAuthToken() ? children : null;
};

export default AuthMiddleware;